import axios from '../../plugins/axios';

export const getMonthlyStates = ({commit}, { year, month}) => {
  const token = JSON.parse(localStorage.getItem('user')).token
  const config = {
    headers: { Authorization: `Bearer ${token}` }
  }
  return axios.get(`/api/monthly-states/year/${year}/month/${month}`, config)
    .then((response) => {
    const businessesMonthlyStates = response.data
    commit('SET_BUSINESSES_MONTHLY_STATES', { businessesMonthlyStates })
      return response 
    })
    .catch((error) => error.response );
}

export const updateBusinessServiceStates = ({}, { data, year, month }) => {
  const token = JSON.parse(localStorage.getItem('user')).token
  const config = {
    headers: { Authorization: `Bearer ${token}` }
  }
  return axios.put(`/api/monthly-states/year/${year}/month/${month}`, data, config)
    .then((response) => {
      return response 
    })
    .catch((error) => error.response );
}
